<div
  [class.w-full]="fullWidth()"
  [ngStyle]="inputStyles()"
  class="group relative flex items-center gap-3 rounded-xl border border-(--input-border) bg-(--input-bg) px-4 py-3 transition-all duration-200 focus-within:border-(--input-focus-border)"
>
  <input
    #inputEl
    type="text"
    [value]="value()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [readonly]="readonly()"
    (input)="onInput($event)"
    (keydown.enter)="actionClick.emit()"
    class="flex-1 bg-transparent outline-none text-body font-normal leading-none text-(--input-text) placeholder:text-(--input-placeholder) disabled:cursor-not-allowed disabled:opacity-50"
  />

  <button
    type="button"
    [disabled]="disabled()"
    (click)="actionClick.emit()"
    class="inline-flex cursor-pointer items-center justify-center transition-transform duration-200 hover:scale-110 disabled:cursor-not-allowed disabled:opacity-50"
  >
    <bevvi-icon [icon]="actionIcon()" [size]="iconSize.SM" />
  </button>
</div>
